import { Routes } from "@angular/router";
import { UserComponent } from "../user/feature/user.component";
import { AuthGuard } from "../data-services/guards/auth.guard";
import { EventBookingsComponent } from "../user/event-bookings/feature/event-bookings.component";
import { ShowEventBookingComponent } from "../user/show-event-booking/feature/show-event-booking.component";

export const userRoutes: Routes = [
    {
        path: 'account',
        component: UserComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'account/bookings',
        component: EventBookingsComponent,
        canActivate: [AuthGuard],
        data: {
            sidebar: false
        }
    },
    {
        path: 'account/bookings/:id',
        component: ShowEventBookingComponent,
        canActivate: [AuthGuard],
    },
]